<template>
  <div>
    <template>
      <el-row>
        <el-col :span="11">
          <el-table :data="roleList"
                    stripe
                    style="width: 100%">

            <el-table-column prop="name"
                             label="角色名称"
                             width="180">
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-switch v-model="scope.row.status"
                           active-value="TRUE"
                           inactive-value="FALSE"
                           active-color="#13ce66"
                           inactive-color="#ff4949"
                           disabled>
                </el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作">
              <template slot-scope="scope">
                <el-link :underline="false"
                         @click="toEdit(scope.row)">编辑</el-link>

              </template>
            </el-table-column>
          </el-table>
        </el-col>
        <el-col :span="11">
          <el-form ref="form"
                   :model="form"
                   label-width="80px">

            <el-form-item label="名称">
              <el-input v-model="form.name"></el-input>
            </el-form-item>
            <el-form-item label="状态">
              <el-switch v-model="form.status"
                         active-value="TRUE"
                         inactive-value="FALSE"
                         active-color="#13ce66"
                         inactive-color="#ff4949">
              </el-switch>
            </el-form-item>
            <el-form-item label="权限">
              <template>

                <el-table ref="multipleTable"
                          :data="totalUrls"
                          tooltip-effect="dark"
                          style="width: 100%"
                          @selection-change="handleSelectionChange">
                  <el-table-column type="selection"
                                   width="55">
                  </el-table-column>

                  <el-table-column prop="name"
                                   label="名称"
                                   width="120">
                  </el-table-column>
                  <el-table-column prop="path"
                                   label="地址">
                  </el-table-column>
                </el-table>
              </template>

            </el-form-item>
            <el-form-item>
              <el-button type="primary"
                         @click="onSubmit">
                <template v-if="form.id">
                  修改
                </template>
                <template v-else>
                  添加
                </template>
              </el-button>
              <el-button @click="form={};  $refs.multipleTable.clearSelection()"> 清空</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>

    </template>

  </div>
</template>

<script>

import axios from 'axios'

export default {
  name: 'ele',
  data: function () {
    return {
      urlDialogVisible: false,
      status: 'TRUE',
      roleList: [],
      form: {},
      curUrls: [],
      totalUrls: []
    }
  },
  filters: {
    typeFilter: function (v) {
      switch (v) {
        case 'SXN':
          return '雪宁'
        case 'LYD':
          return '彦东'
        case 'KBX':
          return '保星'
        default:
          return '未知'
      }
    }
  },

  computed: {

  },
  methods: {
    getTotalUrl () {
      let _this = this
      axios.get('/api/web/admin/urlList?status=' + this.urlStatus).then(resp => {
        _this.totalUrls = []
        if (resp.data) {
          _this.totalUrls = resp.data
        }
      })
    },
    getList () {
      let _this = this
      axios.get('/api/web/admin/roleList?status=' + this.status).then(resp => {
        _this.roleList = resp.data
      })
    },

    onSubmit () {
      let _this = this
      axios.post('/api/web/admin/saveRole', this.form).then(resp => {
        _this.form.id = resp.data
        axios.post('/api/web/admin/saveUrlsByRole', {
          roleId: _this.form.id,
          ids: _this.curUrls.map((obj, index) => {
            return obj.id
          }).join(',').split(',')
        }).then(r => {
          _this.form = {}
          _this.$refs.multipleTable.clearSelection()
        })
      })
    },
    toEdit (row) {
      this.$refs.multipleTable.clearSelection()
      this.form = row
      let _this = this
      axios.get('/api/web/admin/urlsByRole?roleId=' + this.form.id).then(resp => {
        if (resp.data) {
          _this.totalUrls.forEach(t => {
            resp.data.forEach(c => {
              if (t.id === c.id) {
                _this.$refs.multipleTable.toggleRowSelection(t)
              }
            })
          })
        }
      })
    },
    handleSelectionChange (val) {
      this.curUrls = val
    }
  },

  mounted () {
    this.getList()
    this.getTotalUrl()
  }
}
</script>
<style lang="less" scoped>
</style>



// WEBPACK FOOTER //
// src/app/developer/roles.vue